import Close from 'assets/icons/close.svg'
import CheckIconSvg from 'assets/icons/nucleo/18px_circle-check-2.svg'
import { unifiedColors } from 'styles/colors'
import { styled } from 'styles/styled'
import { theme, themeUtils } from 'styles/theme'

export const DialogStyle = {
  Sx: {
    '.MuiPaper-root': {
      width: '416px',
      height: 'auto',
      border: `2px solid ${unifiedColors.surface.blue}`,
      boxShadow: `2px 3px 0px 0px ${unifiedColors.surface.blue}`
    }
  }
}

export const CheckIcon = styled(CheckIconSvg)`
  color: ${theme.palette.label.success};
  width: 40px;
`

export const DialogTopBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  background-color: ${theme.palette.surface.subdued};
  border-bottom: 1px solid #28253b0f;
  padding: 16px 20px;
`

export const ModalTitle = styled.p`
  ${themeUtils.h5}
  text-transform: uppercase;
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
`

export const ExplanationText = styled.p`
  ${themeUtils.bodyXSmall}
  white-space: pre-wrap;
`

export const CloseIcon = styled(Close)`
  cursor: pointer;
`

export const ModalFooter = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #28253b0f;
  display: flex;
  justify-content: center;
`
